import { track } from '@vercel/analytics';

type TrackPayload = Record<string, any>;

let currentUserEmail: string | undefined;

export const setAnalyticsUser = (email?: string | null) => {
  currentUserEmail = email || undefined;
};

const cleanLabel = (value?: string | null) => {
  if (!value) return undefined;
  return value.trim().replace(/\s+/g, ' ').slice(0, 120) || undefined;
};

const buildButtonLabel = (el: HTMLElement) => {
  return cleanLabel(
    el.dataset.trackLabel ||
      el.getAttribute('aria-label') ||
      el.textContent
  );
};

export const trackEvent = (name: string, properties?: TrackPayload) => {
  try {
    const enriched = {
      ...properties,
      userEmail: properties?.userEmail ?? currentUserEmail,
    };
    track(name, enriched);
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('Analytics track failed', error);
    }
  }
};

export const startGlobalButtonTracking = () => {
  if (typeof document === 'undefined') return () => {};

  const handleClick = (event: MouseEvent) => {
    const target = event.target as HTMLElement | null;
    if (!target) return;

    const button = target.closest<HTMLElement>('button, [role="button"]');
    if (!button || button.dataset.trackSkipGlobal === 'true') return;

    const eventName = button.dataset.trackEvent || 'ui_button_press';
    const label = buildButtonLabel(button);
    const context = button.dataset.trackContext;
    const detail = button.dataset.trackDetail;

    trackEvent(eventName, {
      label,
      context,
      detail,
      id: button.id || undefined,
      path: typeof window !== 'undefined' ? window.location.pathname : undefined,
    });
  };

  document.addEventListener('click', handleClick, true);
  return () => document.removeEventListener('click', handleClick, true);
};
